<ng-container *ngIf="client$ | async as client">
	<app-edit-person-client
		*ngIf="client.type === clientTypes.PERSON"
		[client]="client"
	></app-edit-person-client>
	<app-edit-business-client
		*ngIf="client.type !== clientTypes.PERSON"
		[company]="client"
	></app-edit-business-client>
</ng-container>
